// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__38J7n","description":"PatientConsentPreview_description__1kbvH"};